export * from './checkbox';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/checkbox/index.js
// module id = 279
// module chunks = 0